// extracted by mini-css-extract-plugin
export var quantityInput = "_k7-0";